/* eslint-disable */
/* tslint:disable */
/*
 * -------------------------------------------------------------------
 * ## THIS FILE WAS GENERATED via our custom react-query-generator  ##
 * ##                                                               ##
 * ## DO NOT MODIFY                                                 ##
 * -------------------------------------------------------------------
 *
 * Tanstack Query Version : `4`
 *
 * Implementation for `patVideoSessionsWaitingPositionByVideoSessionId` hook
 * Endpoint: `/pat/video-sessions/{videoSessionId}/waiting-position`
 */

import { useQueryClient, useQuery } from "@tanstack/react-query";

import omitBy from "lodash/omitBy";
import pick from "lodash/pick";

export function makeQueryKey(params) {
	return [
		"@@api-patient",
		"pat",
		"video-sessions",
		params.videoSessionId,
		"waiting-position",
	];
}

export function useInvalidateQuery() {
	const queryClient = useQueryClient();
	return function invalidateQuery(params) {
		return queryClient.invalidateQueries({
			queryKey: makeQueryKey(params).filter(Boolean),
		});
	};
}

export function useGet(params, options) {
	return useQuery({
		...options,
		queryKey: makeQueryKey(params),
		// only enable hook if all required params are passed at runtime (don't trust the developer who could cast)
		enabled: !!params.videoSessionId && options?.enabled !== false,
	});
}

export function prefetch(queryClient, params, options) {
	return queryClient.prefetchQuery({
		...options,
		queryKey: makeQueryKey(params),
	});
}
